<template>
    <div id="container" class="shadow-sm">
        <router-link :to="mapUrl"><img class="mapBanner" :src="mapBannerUrl" /></router-link>
        <div class="mapTitle">{{ name }}</div>
        <router-link :to="mapUrl">{{ $t("admin.maps.open") }}</router-link>
    </div>
</template>

<script>
import Map from "@/model/Map.js";
import LangUtils from "@/utils/LangUtils.js";

export default {
    name: "MapBox",
    props: {
        map: Map
    },
    computed: {
        name() {
            return this.map != null ? LangUtils.valueForLanguage(this.map.getName(), this.$i18n.locale) : "";
        },

        mapBannerUrl() {
            return this.map != null ? "https://images.weserv.nl/?url=" + LangUtils.valueForLanguage(this.map.getMapBannerUrl(), this.$i18n.locale) : "";
        },

        mapUrl() {
            return this.map != null ? "/admin/map/" + this.map.getId() : "";
        }
    }
}
</script>

<style scoped>
#container {
    background-color: #ffffff;
    border-radius: 8px;
    padding: 16px;
    text-align: left;

    width: 300px;
    height: 350px;
}

h1 {
    font-size: 32px;
    text-align: left;
}

.mapBanner {
    width: 270px;
    height: 200px;
    object-fit: cover;
}

.mapTitle {
    font-size: 18px;
    font-weight: bold;
    margin-top: 8px;
}
</style>
